import React, { useState, useEffect } from 'react';
import { PatriotResult, AkaResult } from '../../AutomateNamesTypes';

interface PropTypes {
  results: PatriotResult[];
}

const PatriotResults = (props: PropTypes) => {
  return (
    <div>
      <div style={{ border: '2px solid white', borderRadius: 4, padding: 8 }}>
        {props.results.map((pr: PatriotResult, i: any) => {
          return (
            <div style={{ borderBottom: '2px solid #fff', paddingBottom: 12 }}>
              <div style={{ position: 'absolute', left: 8 }}>{`${i + 1}.`}</div>
              <div style={{ margin: '12px 0' }}>
                <b>Name:</b> {pr.name}
              </div>
              <div style={{ marginTop: 12 }}>
                <b>General Remarks: </b> {pr.generalRemarks}
              </div>
              <div style={{ marginTop: 12 }}>
                <b>AKA: </b>
                {pr.akaResults.map((ar: AkaResult) => {
                  return <p>{ar.akaName}</p>;
                })}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default PatriotResults;
